// removed by extract-text-webpack-plugin
module.exports = {"container":"_2APmc","body":"_3FpwH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/Featured.less
// module id = ./src/components/Home/Featured.less
// module chunks = 2